const Theme = {
  body_background_image_url: 'gitanyow.png',
  body_background_image_contain: true,

  header_border_color: '#b89b6b',

  logo_image_url: 'gitanyow.png',
  logo_height: 200,

  token_url: 'gitanyow.png',
  token_width: 60,

  number_hidden: true,

  button_color: '#b89b6b',
  button_text_lineheight: 23.04,
  button_text_size: 14.4,
  button_text_weight: 400,
  button_border_width: 1,
  button_text_letter_spacing: 1.44,

  button_half_font: `'Special Elite', sans-serif`,
  button_half_border_color: '#262425',
  button_half_text_weight: 400,
  button_half_text_size: 14.4,

  text_font: `'Open Sans', sans-serif`,
  text_color: '#262425',
  text_size: 16,
  text_lineheight: 25.6,

  title_font: `'Open Sans', sans-serif`,
  title_color: '#262425',
  title_size: 25.6,
  title_lineheight: 35.84,
  title_letter_spacing: 2.048,
  title_uppercase: true,

  subtitle_font: `'Special Elite', sans-serif`,
  subtitle_size: 20,
  subtitle_lineheight: 29.6,
  subtitle_color: '#59595b',
  subtitle_text_transform: 'none',
  subtitle_weight: 700,

  separator_color: '#b89b6b',

  footer_background_color: '#424d21',
  footer_text_color: 'white',
  footer_link_color: '#b89b6b',
}

export default Theme
